export default __webpack_public_path__ + "2b4efcd52ad0c417289c08a1ac488b3d.png";